import React, { useState, useEffect, useCallback } from 'react';
import {
  Box, Typography, Paper, Table, TableHead, TableBody, TableRow, TableCell,
  Chip, Switch,
} from '@mui/material';
import apiClient from '../api/client';

export default function AdminUsers() {
  const [users, setUsers] = useState([]);

  const load = useCallback(async () => {
    const { data } = await apiClient.get('/admin/users');
    setUsers(data.data);
  }, []);

  useEffect(() => { load(); }, [load]);

  const toggleSystemAdmin = async (userId, current) => {
    await apiClient.put(`/admin/users/${userId}`, { is_system_admin: !current });
    load();
  };

  return (
    <Box>
      <Typography variant="h4" fontWeight={700} mb={3}>Users</Typography>
      <Paper sx={{ bgcolor: '#1e293b' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ color: '#94a3b8' }}>Name</TableCell>
              <TableCell sx={{ color: '#94a3b8' }}>Email</TableCell>
              <TableCell sx={{ color: '#94a3b8' }}>System Admin</TableCell>
              <TableCell sx={{ color: '#94a3b8' }}>Organizations</TableCell>
              <TableCell sx={{ color: '#94a3b8' }}>Joined</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.length === 0 && (
              <TableRow><TableCell colSpan={5} align="center" sx={{ color: '#64748b' }}>No users yet</TableCell></TableRow>
            )}
            {users.map(u => (
              <TableRow key={u.id} hover sx={{ '&:hover': { bgcolor: '#334155' } }}>
                <TableCell sx={{ color: '#f1f5f9' }}>{u.first_name} {u.last_name}</TableCell>
                <TableCell sx={{ color: '#94a3b8' }}>{u.email}</TableCell>
                <TableCell>
                  <Switch size="small" checked={u.is_system_admin} onChange={() => toggleSystemAdmin(u.id, u.is_system_admin)} />
                </TableCell>
                <TableCell>
                  <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                    {u.orgRoles?.filter(r => !r.organization?.is_personal).length === 0
                      ? <Typography variant="caption" sx={{ color: '#64748b' }}>Independent</Typography>
                      : u.orgRoles?.filter(r => !r.organization?.is_personal).map(r => (
                          <Chip key={r.id} label={`${r.organization?.name}: ${r.role}`} size="small" variant="outlined" sx={{ color: '#94a3b8', borderColor: '#475569' }} />
                        ))
                    }
                  </Box>
                </TableCell>
                <TableCell sx={{ color: '#64748b', fontSize: 12 }}>
                  {new Date(u.createdAt).toLocaleDateString()}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
